export const isDomainValidator = (value: string): boolean => {
  const re = /^(?!-)(?!.*--)(?!.*\.$)(?!.*\.\.)((?:[a-zA-Z0-9](?:-?[a-zA-Z0-9]){0,62})\.)+[a-zA-Z]{2,63}$/
  return re.test(value)
}
